var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-ruler"},[_c('div',{staticClass:"spacer"}),_c('div',{staticClass:"ruler"}),_c('div',{staticClass:"spacer"})])
}]

export { render, staticRenderFns }